// extracted by mini-css-extract-plugin
export default {"bannerSection":"ResponsiveBanner_bannerSection__shQtX","bannerImage":"ResponsiveBanner_bannerImage__g7aVe","bannerText":"ResponsiveBanner_bannerText__hEKQX"};